import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';

/**
 * Composable to determine if the current user is an manager.
 * @returns {Boolean} - True if the current user is an manager, false otherwise.
 */
export function useManager() {
  const getters = useStoreGetters();
  const { t } = useI18n();

  const currentUserRole = computed(() => getters.getCurrentRole.value);
  const isManager = computed(() => currentUserRole.value === 'manager');

  const allowedApps = [
    {
      id: 'google_calendar',
      name: 'Google Agenda',
      description: t('INTEGRATION_APPS.GOOGLE_CALENDAR.DESCRIPTION'),
      enabled: true,
      logo: 'googlecalendar.png',
      i18n_key: 'google_calendar',
      action: '/google_calendar',
      hook_type: 'account',
      allow_multiple_hooks: false,
      button: '/google_calendar',
      hooks: [],
    },
    {
      id: 'jira',
      name: 'Jira',
      description: t('INTEGRATION_SETTINGS.JIRA.DESCRIPTION'),
      enabled: true,
      logo: 'jira.png',
      i18n_key: 'jira',
      action: '/jira',
      hook_type: 'account',
      allow_multiple_hooks: false,
      button: '/jira',
      hooks: [],
    },
  ];

  return {
    isManager,
    allowedApps,
  };
}
